import { useContext } from 'react'
import { UndoRedoContext } from '../../context/UndoRedoContext'
import { Typography, useTheme } from '@mui/material'
import { useTrackClickUndoRedo } from '../../services/analytics/hook'
import { ButtonWithTooltip } from '../../components/button'
import { LuUndo2 } from 'react-icons/lu'
import { iconSizeAndColorProps } from '../../theme/constants'

export const UndoButton = ({ isMobile = false }: { isMobile?: boolean }) => {
    const { undo, canUndo } = useContext(UndoRedoContext)
    const trackClickUndoRedo = useTrackClickUndoRedo()

    const handleUndo = () => {
        if (!canUndo()) return
        trackClickUndoRedo()
        undo()
    }

    const disabled = !canUndo()

    return (
        <ButtonWithTooltip disabled={disabled} onClick={() => handleUndo()} tooltipTitle="Undo" width="20px">
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <LuUndo2 {...iconSizeAndColorProps(disabled ? 'disabled' : 'dark')} />
                {isMobile && (
                    <Typography fontSize={9} variant={'caption'}>
                        Undo
                    </Typography>
                )}
            </div>
        </ButtonWithTooltip>
    )
}
